import { useEffect, useState } from "react";

export type Lang = "en" | "ru";

const STORAGE_KEY = "lang";

const dict = {
  en: {
    nav_buy: "Accounts",
    nav_features: "What we offer",
    nav_faq: "FAQ",
    nav_open: "Open in Telegram",

    hero_eyebrow: "International accounts · Issuance · Top-up · Payments",
    hero_title_a: "An account for borderless payments",
    hero_title_b: "worldwide",
    hero_sub: "TTEX is:",
    hero_li1: "an international account",
    hero_li2: "opening and topping up foreign cards",
    hero_li3: "paying foreign invoices",
    hero_cta: "Open a free account in Telegram Bot",

    calc_title: "Top-up calculator",
    calc_send: "You pay",
    calc_receive: "You get",
    calc_send_unit: "RUB · bank transfer",
    calc_btn: "Get started",
    calc_stat_verify: "verification",
    calc_stat_credit: "crediting",
    rate_loading: "Loading rate…",
    rate_one_usdt: "1 USD",


    how_title: "How it works",
    how_sub: "A few steps, all inside Telegram.",
    how_s1_t: "Verify your identity once",
    how_s1_d: "Phone, email and passport details. The process takes a few minutes.",
    how_s2_t: "Get a free account",
    how_s2_d: "A free international account you can top up in rubles from any Russian bank card.",
    how_s3_t: "Open a card or pay an invoice",
    how_s3_d: "Open and top up an international card, or pay a foreign invoice. TTEX sends the money to the required details.",
    how_s4_t: "Pay worldwide",
    how_s4_d: "Pay for purchases worldwide with the physical card and Apple Pay. Cash out back whenever you need.",

    why_title: "What we offer",
    why_sub: "TTEX — remote opening of an international account and cross-border payments.",
    why_1_t: "Free international account",
    why_1_d: "Top up in rubles from any Russian bank.",
    why_2_t: "Physical international card",
    why_2_d: "For payments online, in stores, services and subscriptions.",
    why_3_t: "Apple Pay & Google Pay",
    why_3_d: "Add the card and pay with your phone.",
    why_4_t: "Top up & cash out",
    why_4_d: "Top up your account and withdraw funds anytime.",
    why_5_t: "Simple & transparent",
    why_5_d: "One-time verification, chat support, transparent terms.",

    faq_title: "Frequently asked questions",
    faq_q1: "What cards do you issue?",
    faq_a1:
      "Physical international cards. They support payments worldwide — online and in stores. A card can be added to Apple Pay or Google Pay to pay with your phone.",
    faq_q2: "Can I top up and cash out?",
    faq_a2:
      "Yes — the cards we issue can be topped up and cashed out wherever you need.",
    faq_q3: "Is verification required?",
    faq_a3:
      "Yes, a one-time verification. It takes a few minutes.",
    faq_q4: "How do I get started?",
    faq_a4:
      "Open the bot, verify once, choose your card and top it up. Support is available in-app.",
    faq_q5: "Do I need to fly anywhere to open and receive an international account or card?",
    faq_a5:
      "No, everything is done remotely. You'll need: a photo of your international passport, a phone number, an email and your registration address.",

    contact_title: "Get in touch",
    contact_body:
      "After verification, a chat inside our Telegram app becomes available to you. We'll be happy to answer your questions.",

    cta_title: "Ready to open an account?",
    cta_sub: "Open the bot — verification is one-time, and getting started takes a couple of minutes.",
    cta_btn: "Open @ttex_robot",

    footer_company: "Financial Alliance LLC · Razzakov St 22, Pervomaisky district, Bishkek, Kyrgyz Republic · TIN 01205202310463",
    footer_license: "Securities market brokerage license, registration No. 3056101024 dated 10 October 2024.",
    footer_contact: "client@fa.kg · +996 505 273 072",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms (soon)",
    footer_disclaimer:
      "Service availability depends on your jurisdiction. By using the Service you agree to our Privacy Policy.",

    // ── Signature landing (site_*) ──
    site_nav_about: "Account",
    site_nav_how: "How it works",
    site_nav_calc: "Calculator",
    site_nav_payments: "Payments",
    site_nav_payout: "PayOut",
    site_nav_card: "TTEX Card",
    site_nav_open: "Open account",
    site_theme_light: "Light theme",
    site_theme_dark: "Dark theme",

    site_hero_kicker: "International account",
    site_hero_pre: "An account for borderless ",
    site_hero_accent: "possibilities",
    site_hero_post: " to pay all over the world",
    site_hero_sub:
      "Top up in rubles — pay in the currency you need. An international account and settlements worldwide, right inside Telegram.",
    site_hero_cta1: "Open an account in the bot",
    site_hero_cta2: "Learn more",

    site_trust1_t: "International account",
    site_trust1_d: "A free internal account for payments worldwide.",
    site_trust2_t: "Foreign cards",
    site_trust2_d: "Opening and topping up foreign cards.",
    site_trust3_t: "Invoice payments",
    site_trust3_d: "Paying foreign invoices and SWIFT.",

    site_about_kicker: "What TTEX is",
    site_about_h2: "One account — several payment scenarios",
    site_about_p:
      "An international account and payments worldwide, right inside Telegram. Top up in rubles, pay in the currency you need.",

    site_how_kicker: "How it works",
    site_how_h2: "From sign-up to an international payment",
    site_how_p:
      "The client journey stays simple: KYC once, then top-up, the internal account and the payment route you need.",
    site_how_s1: "Open the TTEX bot or website.",
    site_how_s2: "Pass KYC and sign the account-opening documents.",
    site_how_s3: "Submit a ruble top-up request and receive the details.",
    site_how_s4: "Transfer rubles to the details.",
    site_how_s5: "Receive confirmation of the deposit.",
    site_how_s6: "We credit the rubles to your internal account.",
    site_how_s7: "Spend from the account: top up a foreign card, pay an invoice or SWIFT.",

    site_acc_kicker: "Your account — for any currency",
    site_acc_h2: "What you get",
    site_acc_b1_t: "Buy USD for rubles",
    site_acc_b1_d: "Buying dollars for rubles — for individuals.",
    site_acc_b2_t: "Free account",
    site_acc_b2_d: "An international account for payments — free of charge.",
    site_acc_b3_t: "Pay worldwide",
    site_acc_b3_d: "An invoice, SWIFT or a foreign-card top-up.",
    site_acc_b4_t: "Bring currency back",
    site_acc_b4_d: "From any foreign card — back to a ruble one.",

    site_calc_kicker: "Top-up calculator",
    site_calc_h2: "See right away how much you get",
    site_calc_p1:
      "Enter the amount in rubles — the calculator shows the approximate amount credited in USD before you start.",
    site_calc_p2: "The final rate is locked before payment as part of the request.",
    site_calc_pay: "YOU PAY",
    site_calc_pay_unit: "RUB · bank transfer",
    site_calc_get: "YOU GET",
    site_calc_start: "Get started",
    site_calc_m1_l: "verification",
    site_calc_m2_l: "crediting",

    site_pay_kicker: "Payments all over the world",
    site_pay_h2: "Three ways to spend funds from the account",
    site_pay_p: "For any task.",
    site_pay1_t: "Invoice",
    site_pay1_d: "Paying a foreign supplier invoice.",
    site_pay2_t: "SWIFT",
    site_pay2_d: "An international bank transfer.",
    site_pay3_t: "Foreign card",
    site_pay3_d: "Top up a card — ours or any bank's.",

    site_payout_kicker: "Bring currency back home",
    site_payout_h2: "Returning currency back to a ruble card in Russia",
    site_payout_s1: "You top up your foreign card with currency.",
    site_payout_s2: "You withdraw in rubles to your internal account with us.",
    site_payout_s3: "You submit a payout request to your card at a Russian bank.",
    site_payout_s4: "We pay out to the specified details.",

    site_card_kicker: "TTEX Card",
    site_card_h2: "A foreign card for payments all over the world",
    site_card_soon: "SOON",
    site_uc1: "WORLDWIDE",
    site_uc2: "PAYMENTS",
    site_uc3: "SUBSCRIPTIONS",
    site_uc4: "TRAVEL",
    site_uc5: "SERVICES",

    site_cta_h2: "Open a TTEX account",
    site_cta_p: "Onboarding and requests — in the TTEX bot.",
    site_footer_tagline: "International account and payments all over the world",
  },
  ru: {
    nav_buy: "Зарубежные счета",
    nav_features: "Что мы даём",
    nav_faq: "FAQ",
    nav_open: "Открыть в Telegram",

    hero_eyebrow: "Международные счета · Выпуск · Пополнение · Оплаты",
    hero_title_a: "Счёт для безграничных возможностей оплат",
    hero_title_b: "по всему миру",
    hero_sub: "TTEX — это:",
    hero_li1: "международный счёт",
    hero_li2: "открытие и пополнение зарубежных карт",
    hero_li3: "оплата зарубежных инвойсов",
    hero_cta: "Открыть бесплатный счёт в Telegram Bot",

    calc_title: "Калькулятор пополнения",
    calc_send: "Платите",
    calc_receive: "Получаете",
    calc_send_unit: "RUB · банковский перевод",
    calc_btn: "Начать",
    calc_stat_verify: "верификация",
    calc_stat_credit: "зачисление",
    rate_loading: "Загружаем курс…",
    rate_one_usdt: "1 USD",


    how_title: "Как это работает",
    how_sub: "Несколько шагов, всё в одном Telegram-окне.",
    how_s1_t: "Единоразово подтвердите личность",
    how_s1_d: "Телефон, электронная почта и паспортные данные. Процесс занимает несколько минут.",
    how_s2_t: "Получите бесплатный счёт",
    how_s2_d: "Бесплатный международный счёт с возможностью пополнения рублями с карты любого российского банка.",
    how_s3_t: "Откройте карту или оплатите инвойс",
    how_s3_d: "Откройте и пополните международную карту либо оплатите зарубежный инвойс. TTEX переводит деньги по необходимым реквизитам.",
    how_s4_t: "Платите по всему миру",
    how_s4_d: "Оплачивайте покупки физической картой и через Apple Pay. При необходимости выводите средства обратно.",

    why_title: "Что мы даём",
    why_sub: "TTEX — удалённое открытие международного счёта и трансграничные платежи.",
    why_1_t: "Бесплатный международный счёт",
    why_1_d:
      "Пополнение рублями с карты любого российского банка.",
    why_2_t: "Физическая международная карта",
    why_2_d:
      "Для оплаты онлайн, в магазинах, сервисах и подписках.",
    why_3_t: "Apple Pay и Google Pay",
    why_3_d:
      "Подключите карту и оплачивайте телефоном.",
    why_4_t: "Пополнение и вывод",
    why_4_d:
      "Пополняйте счёт и выводите средства в любой момент.",
    why_5_t: "Просто и прозрачно",
    why_5_d:
      "Разовая верификация, поддержка в чате и прозрачные условия.",

    faq_title: "Часто задаваемые вопросы",
    faq_q1: "Какие карты вы выпускаете?",
    faq_a1:
      "Физические международные карты. Они поддерживают оплату по всему миру — онлайн и в магазинах. Карту можно добавить в Apple Pay или Google Pay и оплачивать покупки телефоном.",
    faq_q2: "Можно ли пополнять карту и выводить с неё?",
    faq_a2:
      "Да — карты, которые мы выпускаем, можно пополнять и выводить с них куда вам нужно.",
    faq_q3: "Нужна ли верификация?",
    faq_a3:
      "Да, разовая верификация. Занимает несколько минут.",
    faq_q4: "Как начать?",
    faq_a4:
      "Откройте бота, пройдите верификацию один раз, выберите карту и пополните её. Поддержка доступна в приложении.",
    faq_q5: "Нужно ли мне куда-то лететь, чтобы открыть и получить международный счёт либо международную карту?",
    faq_a5:
      "Нет, всё оформляется удалённо. Потребуются: фотография заграничного паспорта, номер телефона, электронная почта и адрес регистрации.",

    contact_title: "Связаться с нами",
    contact_body:
      "После верификации вам будет доступен чат внутри нашего приложения в Telegram. Мы с удовольствием ответим на ваши вопросы.",

    cta_title: "Готовы открыть счёт?",
    cta_sub: "Откройте бота — верификация одноразовая, а начать можно за пару минут.",
    cta_btn: "Открыть @ttex_robot",

    footer_company: "ОсОО «Финансовый Альянс» · Кыргызская Республика, г. Бишкек, Первомайский р-н, ул. Раззакова, д. 22 · ИНН 01205202310463",
    footer_license: "Лицензия на осуществление брокерской деятельности на рынке ценных бумаг, регистрационный номер 3056101024 от 10 октября 2024 года.",
    footer_contact: "client@fa.kg · +996 505 273 072",
    footer_privacy: "Политика конфиденциальности",
    footer_terms: "Условия (скоро)",
    footer_disclaimer:
      "Доступность сервиса зависит от вашей юрисдикции. Используя сервис, вы соглашаетесь с Политикой конфиденциальности.",

    // ── Signature landing (site_*) ──
    site_nav_about: "О счёте",
    site_nav_how: "Как это работает",
    site_nav_calc: "Калькулятор",
    site_nav_payments: "Оплаты",
    site_nav_payout: "PayOut",
    site_nav_card: "TTEX Card",
    site_nav_open: "Открыть счёт",
    site_theme_light: "Светлая тема",
    site_theme_dark: "Тёмная тема",

    site_hero_kicker: "Международный счёт",
    site_hero_pre: "Счёт для безграничных ",
    site_hero_accent: "возможностей",
    site_hero_post: " оплат по всему миру",
    site_hero_sub:
      "Пополняете рублями — платите в нужной валюте. Международный счёт и расчёты по всему миру — прямо из Telegram.",
    site_hero_cta1: "Открыть счёт в боте",
    site_hero_cta2: "Узнать больше",

    site_trust1_t: "Международный счёт",
    site_trust1_d: "Бесплатный внутренний счёт для оплат по миру.",
    site_trust2_t: "Зарубежные карты",
    site_trust2_d: "Открытие и пополнение зарубежных карт.",
    site_trust3_t: "Оплата инвойсов",
    site_trust3_d: "Оплата зарубежных инвойсов и SWIFT.",

    site_about_kicker: "Что такое TTEX",
    site_about_h2: "Один счёт — несколько платёжных сценариев",
    site_about_p:
      "Международный счёт и оплаты по всему миру — прямо из Telegram. Пополняете рублями, платите в нужной валюте.",

    site_how_kicker: "Как это работает",
    site_how_h2: "От регистрации до международной оплаты",
    site_how_p:
      "Путь клиента остаётся простым: KYC один раз, далее — пополнение, внутренний счёт и нужный платёжный маршрут.",
    site_how_s1: "Заходите в бота или на сайт TTEX.",
    site_how_s2: "Проходите KYC и подписываете документы на открытие счёта.",
    site_how_s3: "Оставляете заявку на пополнение в рублях и получаете реквизиты.",
    site_how_s4: "Переводите рубли по реквизитам.",
    site_how_s5: "Получаете подтверждение зачисления.",
    site_how_s6: "Мы зачисляем рубли на ваш внутренний счёт.",
    site_how_s7: "Выводите со счёта: пополнение зарубежной карты, оплата инвойса или SWIFT.",

    site_acc_kicker: "Ваш счёт — для любых валют",
    site_acc_h2: "Что вы получаете",
    site_acc_b1_t: "Купить USD за рубли",
    site_acc_b1_d: "Покупка долларов за рубли — для физических лиц.",
    site_acc_b2_t: "Бесплатный счёт",
    site_acc_b2_d: "Международный счёт для оплат — бесплатно.",
    site_acc_b3_t: "Оплатить по миру",
    site_acc_b3_d: "Инвойс, SWIFT или пополнение зарубежной карты.",
    site_acc_b4_t: "Вернуть валюту",
    site_acc_b4_d: "С любой зарубежной карты — обратно на рублёвую.",

    site_calc_kicker: "Калькулятор пополнения",
    site_calc_h2: "Сразу видите, сколько получите",
    site_calc_p1:
      "Введите сумму в рублях — калькулятор покажет ориентировочную сумму зачисления в USD до начала операции.",
    site_calc_p2: "Финальный курс фиксируется перед оплатой в рамках заявки.",
    site_calc_pay: "ПЛАТИТЕ",
    site_calc_pay_unit: "RUB · банковский перевод",
    site_calc_get: "ПОЛУЧАЕТЕ",
    site_calc_start: "Начать",
    site_calc_m1_l: "верификация",
    site_calc_m2_l: "зачисление",

    site_pay_kicker: "Оплата по всему миру",
    site_pay_h2: "Три способа потратить средства со счёта",
    site_pay_p: "Под любую задачу.",
    site_pay1_t: "Инвойс",
    site_pay1_d: "Оплата зарубежного инвойса поставщику.",
    site_pay2_t: "SWIFT",
    site_pay2_d: "Международный банковский перевод.",
    site_pay3_t: "Зарубежная карта",
    site_pay3_d: "Пополнение карты — нашей или любого банка.",

    site_payout_kicker: "Вернуть валюту домой",
    site_payout_h2: "Возврат валюты обратно на рублёвую карту в РФ",
    site_payout_s1: "Пополняете валютой свою зарубежную карту.",
    site_payout_s2: "Выводите в рублях на внутренний счёт у нас.",
    site_payout_s3: "Делаете заявку на вывод на свою карту в банке РФ.",
    site_payout_s4: "Мы выплачиваем на указанные реквизиты.",

    site_card_kicker: "TTEX Card",
    site_card_h2: "Зарубежная карта для оплат по всему миру",
    site_card_soon: "СКОРО",
    site_uc1: "WORLDWIDE",
    site_uc2: "ОПЛАТА",
    site_uc3: "ПОДПИСКИ",
    site_uc4: "ПОЕЗДКИ",
    site_uc5: "СЕРВИСЫ",

    site_cta_h2: "Откройте счёт TTEX",
    site_cta_p: "Оформление и заявки — в боте TTEX.",
    site_footer_tagline: "Международный счёт и оплаты по всему миру",
  },
} as const;

export type DictKey = keyof typeof dict.en;

function detectLang(): Lang {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "en" || saved === "ru") return saved;
  } catch {
    /* ignore */
  }
  const nav = typeof navigator !== "undefined" ? navigator.language?.toLowerCase() ?? "" : "";
  return nav.startsWith("ru") ? "ru" : "en";
}

export function useI18n() {
  const [lang, setLang] = useState<Lang>(() => detectLang());

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      /* ignore */
    }
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const t = (key: DictKey): string => dict[lang][key];
  return { lang, setLang, t };
}
